import * as React from "react";
import * as actions from "../actions/";
import { connect } from "react-redux";
import SignIn from "./sign-in";
import axios from "axios";
const IconMenu = require("!svg-react-loader?name=LiquorIcon!../../wwwroot/img/icons/icon-menu.svg");
const IconShoppingList = require("!svg-react-loader?name=LiquorIcon!../../wwwroot/img/icons/icon-shopping-list.svg");
const IconSearch = require("!svg-react-loader?name=LiquorIcon!../../wwwroot/img/icons/icon-search.svg");
const IconLogin = require("!svg-react-loader?name=LiquorIcon!../../wwwroot/img/icons/icon-login.svg");
export class Header extends React.Component {
    constructor(props) {
        super(props);
        this.authenticated = false;
        this.toggleModal = () => {
            if (this.props.ToggleLogin) {
                this.props.ToggleLogin();
            }
        };
        this.state = {
            toggleMobile: false
        };
    }
    componentDidMount() {
        if (this.props.SetAuth) {
            let htmlSelector = document.querySelector("html");
            let login = Boolean(JSON.parse(htmlSelector.getAttribute("data-authenticated")));
            this.props.SetAuth(login);
            axios
                .get("/Manage/GetShoppingList")
                .then(response => {
                let slist = response.data.shoppingList;
                if (this.props.GetList && slist) {
                    this.props.GetList(slist);
                }
                return axios.get("/Manage/GetFavoriteStore");
            })
                .then(response => {
                let flist = response.data.favoriteStore;
                if (this.props.GetFavorite && flist) {
                    this.props.GetFavorite(flist);
                }
            });
            this.props.SetAuth(login);
        }
    }
    render() {
        let items = this.props.shoppingList && this.props.shoppingList.length ? (React.createElement("span", { className: "shopping-list__items" }, this.props.shoppingList.length)) : null;
        let mobileClass = this.props.mobile
            ? "mobile-menu-toggle active"
            : "mobile-menu-toggle";
        return (React.createElement("header", { className: "site-header" },
            React.createElement(SignIn, { modalOpen: this.props.signInModal, fromHeader: this.props.signInFromHeader, toggle: this.props.ToggleLogin }),
            React.createElement("div", { className: "first-level" },
                React.createElement("nav", null,
                    React.createElement("a", { href: "/Home/StoreLocator" }, "STORE LOCATOR"),
                    React.createElement("a", { href: "/Home/Events" }, "EVENTS"),
                    React.createElement("a", { href: "/Home/Contact" }, "CONTACT"),
                    React.createElement("a", { href: "/Home/PrivacyPolicy" }, "PRIVACY POLICY"),
                    React.createElement("a", { href: "/Home/Social" }, "SOCIAL RESPONSIBILITY"),
                    React.createElement("a", { href: "/Home/Faq" }, "FAQ"),
                    this.props.authenticated ? (React.createElement("form", { className: "sign-out", action: "/Account/Logout", method: "post" },
                        React.createElement("button", { type: "submit" }, "Sign Out"))) : (React.createElement("a", { href: "#", onClick: this.toggleModal }, "SIGN IN")))),
            React.createElement("div", { className: "second-level" },
                React.createElement("div", { className: "logo" },
                    React.createElement("a", { href: "/" },
                        React.createElement("img", { src: "/img/LiquorConnect_logo.png" }))),
                React.createElement("nav", { className: "main-route" },
                    React.createElement("a", { className: this.props.route === "AlbertaMade" ? "active" : "", href: "/Products/Search?madeInAlberta=true" }, "ALBERTA MADE"),
                    React.createElement("a", { className: this.props.route === "Wine" ? "active" : "", href: "/Products/Search?category=WINE" }, "WINE"),
                    React.createElement("a", { className: this.props.route === "Beer" ? "active" : "", href: "/Products/Search?category=BEER" }, "BEER"),
                    React.createElement("a", { className: this.props.route === "Spirits" ? "active" : "", href: "/Products/Search?category=SPIRITS" }, "SPIRITS"),
                    React.createElement("a", { className: this.props.route === "Liqueurs" ? "active" : "", href: "/Products/Search?category=LIQUEUR" }, "LIQUEURS"),
                    React.createElement("a", { className: this.props.route === "Ciders & Coolers"
                            ? "active"
                            : "", href: "/Products/Search?category=CIDERS%20%26%20COOLERS" }, "CIDERS & COOLERS"),
                    React.createElement("a", { className: this.props.route === "Non-Alcoholic" ? "active" : "", href: "/Products/Search?liqType=NON-ALCOHOLIC&category=NON-ALCOHOLIC" }, "NON-ALCOHOLIC"),
                    React.createElement("a", { className: this.props.route === "Other" ? "active" : "", href: "/Products/Search?liqType=LIQUOR%20ACCESSORIES%2CPRODUCT%20PACKAGING&category=NON-ALCOHOLIC" }, "OTHER")),
                React.createElement("div", { className: "icon-group" },
                    React.createElement("a", { href: "#", className: "search-toggle", onClick: () => {
                            this.props.toggle();
                        } },
                        React.createElement(IconSearch, null),
                        React.createElement("span", { className: "label" }, "Search")),
                    this.props.authenticated ? (React.createElement("a", { className: "shopping-list", href: "/Products/ShoppingList" },
                        React.createElement(IconShoppingList, null),
                        React.createElement("span", { className: "label" }, "Shopping List"),
                        items)) : (React.createElement("a", { href: "#", className: "signin-mobile", onClick: this.toggleModal },
                        React.createElement(IconLogin, null),
                        React.createElement("span", { className: "label" }, "Sign In"))),
                    React.createElement("a", { href: "#", className: mobileClass, onClick: this.props.toggleMobile },
                        React.createElement(IconMenu, null),
                        React.createElement("span", { className: "label" }, "Menu"))))));
    }
}
export function mapStateToProps({ shoppingList, authenticated, signInModal, signInFromHeader }, OwnProps) {
    return {
        shoppingList,
        authenticated,
        signInModal,
        signInFromHeader,
        route: OwnProps.route,
        mobile: OwnProps.mobile,
        toggle: OwnProps.toggle,
        toggleMobile: OwnProps.toggleMobile
    };
}
export function mapDispatchToProps(dispatch) {
    return {
        SetAuth: (login) => dispatch(actions.SetAuth(login)),
        GetList: (slist) => dispatch(actions.GetList(slist)),
        GetFavorite: (flist) => dispatch(actions.GetFavorite(flist)),
        ToggleLogin: () => dispatch(actions.ToggleLogin())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);
//# sourceMappingURL=header.js.map